import styled from 'styled-components';

export const DesktopMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LogoImage = styled.img<{ $height?: string; $maxWidth?: string }>`
  height: ${({ $height }) => $height};
  max-width: ${({ $maxWidth }) => $maxWidth ?? 'auto'};
  object-fit: contain;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 42px;
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderWrapper = styled.div<{ $themeColor?: string }>`
  background-color: ${({ $themeColor }) => $themeColor ?? 'transparent'};
  width: 100%;
  height: 48px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-left: 100px;
  padding-right: 100px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;
